module.exports = __webpack_public_path__ + "images/8a48d510.img_chs_6.png";


//////////////////
// WEBPACK FOOTER
// ./images/img_chs_6.png
// module id = 309
// module chunks = 0